import React from "react";
import PrettyDate from "../../common/components/PrettyDate";
import CommunicationRecommendation from "./CommunicationRecommendation";
import { communicatedViaToDisplay, validityPeriodToDisplay } from "../../common/displayUtils";
import { LIGHT_TEXT_COLOR } from "../../common/styles";
import DemoModeTag from "../components/DemoModeTag";


const contentTdStyles = {
    padding: 4
};

const contentThStyles = Object.assign({}, contentTdStyles, {
    color: LIGHT_TEXT_COLOR,
    textAlign: "right",
    fontWeight: "normal",
    width: 120,
    paddingLeft: 0,
    verticalAlign: "top"
});

const CommunicationDetails = (props) => {
    let content = <div style={{color: "#888"}}>Select a communication to view details</div>;
    const communication = props.communication;

    if (communication) {
        content = (
            <div>
                <table style={{marginBottom: 10}}>
                    <tbody>
                        <tr>
                            <th style={contentThStyles}>Communicated By</th>
                            <td style={contentTdStyles}>
                                <span className="x-communicator-name">{ communication.communicator !== null ? `${communication.communicator.firstName} ${communication.communicator.lastName}` : "" }</span>
                                { communication.live
                                    ? null
                                    : <DemoModeTag style={{ display: "inline-block", marginLeft: "0.5em" }}>demo user</DemoModeTag> }
                            </td>
                        </tr>
                        <tr>
                            <th style={contentThStyles}>Via</th>
                            <td style={contentTdStyles}>{ communicatedViaToDisplay(communication.communicationMethod) }</td>
                        </tr>
                        <tr>
                            <th style={contentThStyles}>Communicated On</th>
                            <td style={contentTdStyles}><PrettyDate date={communication.disseminationTimestamp} timeOnSameLine={true} /></td>
                        </tr>
                        <tr>
                            <th style={contentThStyles}>Entered On</th>
                            <td style={contentTdStyles}><PrettyDate date={communication.creationTimestamp} timeOnSameLine={true} /></td>
                        </tr>
                        <tr>
                            <th style={contentThStyles}>Sent To</th>
                            <td style={contentTdStyles}>{communication.recipientsEmailAddresses && communication.recipientsEmailAddresses.map(r => <div>{r}</div>)}</td>
                        </tr>
                        <tr>
                            <th style={contentThStyles}></th>
                            <td style={contentTdStyles}>TIM { communication.sendEmail ? "did" : "did not" } email the disclosures to the recipients automatically.</td>
                        </tr>
                    </tbody>
                </table>
                {

                    communication.presentations.map((presentation, index) => {
                        const validityPeriod  = presentation.recommendationTimeHorizon ? validityPeriodToDisplay(presentation.recommendationTimeHorizon.replace("TIME_HORIZON_", "VALIDITY_PERIOD_"))
                                                                                       : "—";
                        const firstLeg = presentation.legs[0];
                        const conflictOfInterest = firstLeg.hasConflictOfInterest ? `Yes, ${firstLeg.conflictOfInterestDetails}` : "No";

                        return (
                            <div key={firstLeg.legId} style={{marginBottom: 10}}>
                                <div style={{marginLeft: 10}}>
                                    <CommunicationRecommendation {...presentation}
                                                                 index={index}
                                                                 validityPeriod={validityPeriod}
                                                                 conflictOfInterest={conflictOfInterest}/>
                                </div>
                            </div>
                        );
                    })

                }
            </div>
        );
    }

    return <div>{ content }</div>;
};

export default CommunicationDetails



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/CommunicationDetails.js
 **/